import { getAppLanguage } from '../../optionsStorage';
export default () => {
    customEvents.on('mineflayerBotCreated', () => {
        bot.loadPlugin(plugin);
    });
};
const plugin = (bot) => {
    bot.settings['locale'] = getAppLanguage();
};
